let initialStickerRotation = null;
let initialTouchRotation = null;

export const onPinchStart = (evt, state) => {
  initialStickerRotation =
    state.stickers[state.active].rotation * (180 / Math.PI);
  initialTouchRotation = evt.rotation;
};

export const onPinchMove = evt => state => {
  if (initialStickerRotation === null || initialTouchRotation === null) {
    return;
  }

  const activeSticker = state.stickers[state.active];

  activeSticker.scale = activeSticker.prevState.scale * evt.scale;
  activeSticker.rotation =
    (initialStickerRotation + (evt.rotation - initialTouchRotation)) *
    (Math.PI / 180);

  return state;
};

export const onPinchEnd = evt => state => {
  const activeSticker = state.stickers[state.active];

  state.actions.push({
    type: "EDIT",
    target: state.active,
    prevState: {
      ...activeSticker.prevState,
      scale: activeSticker.prevState.scale,
      rotation: activeSticker.prevState.rotation
    }
  });

  initialStickerRotation = null;
  initialTouchRotation = null;

  activeSticker.prevState.scale = activeSticker.scale;
  activeSticker.prevState.rotation = activeSticker.rotation;

  return state;
};

export default {
  onPinchMove,
  onPinchEnd
};



// WEBPACK FOOTER //
// ./src/actions/touch.js